import React from 'react'
import '../styles/Header.css'
import pic from '../assets/pic3.jpg'
import qr1 from '../assets/df1.png'
import qr2 from '../assets/df2.png'
import qr3 from '../assets/df3.png'
import qr4 from '../assets/df4.png'
import CustomizedDialogs from './sub/Popup'
export default function Header() {
    return (
        <div className='Header_container'id="Header_container">
            <img src={pic} id="head_img"/>
            <article>
                <h1>Brewing Banner Project</h1>
                <h2>We love QR codes and so do you!!!</h2>
            </article>
            <section>
                <div id="content">
                    <h1>Hey, this is Brewing banner project!!</h1>
                    <p> with its first project - brewing banner project.
                        Its based on a unique idea of a matrix barcode invented in 1994, well you must have used it - QR codes.<br></br>
                        Its the new gen. super cool codes for instant links and referrals.
                        This polygon based blockchain project is based on computer generated 10K unique QR codes. Each one of which displays a unique message which is handpicked. The message displayed is a kind of human emotion such as one-liners, slangs & some heart touching lines too. Well that's not all some things are better kept secret 😉
                    </p>
                    <CustomizedDialogs/>
                </div>
                <div id="image_grid">
                    <img src={qr1} />
                    <img src={qr2} />
                    <img src={qr3} />
                    <img src={qr4} />
                </div>
            </section>

        </div>
    )
}
